import { useState, useEffect, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import "../styles/Header.css";
import Logo from '../images/fcs-logo.png'

/* active link styles */
const navStyles = `
.nav-links a, .offcanvas-body a{
  color: #fff;
  text-decoration:none;
  transition:0.25s ease;
  padding:6px 12px;
  border-radius:14px;
  display:inline-block
}
.nav-links a:hover{color: #9D87BD}
.nav-links a.active{
  background: linear-gradient(135deg, #564C8D, #9D87BD);
  color:white !important
}
`;

export default function Header() {

  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();
  const offcanvasRef = useRef(null);

  /* ---------------- INIT OFFCANVAS ---------------- */
  useEffect(() => {
    const el = document.getElementById("mobileMenu");
    if (!el) return;

    offcanvasRef.current = new Offcanvas(el);
  }, []);

  /* ---------------- CLOSE ON ROUTE CHANGE ---------------- */
  useEffect(() => {
    offcanvasRef.current?.hide();
    setOpenDropdown(null);
  }, [location.pathname]);

  /* ---------------- FUNCTIONS ---------------- */
  const toggleDropdown = (name) => {
    setOpenDropdown(prev => (prev === name ? null : name));
  };

  const openMobile = () => {
    offcanvasRef.current?.show();
  };

  const closeMobile = () => {
    offcanvasRef.current?.hide();
  };

  const dropdownAnim = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 10 },
    transition: { duration: 0.2 }
  };

  return (
    <>
      <style>{navStyles}</style>

      <div className="header-wrapper">
        <nav className="navbar">

          {/* LOGO */}
          <div className="logo-section">
            <Link to="/" onClick={closeMobile}>
              <img src={Logo} alt="Fortune Cloud" className="logo-img" />
            </Link>
          </div>

          {/* DESKTOP NAV */}
          <ul className="nav-links d-none d-lg-flex">
            <li><NavLink to="/">HOME</NavLink></li>

            <li
              className="has-dropdown position-relative px-3"
              onMouseEnter={() => setOpenDropdown("about")}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <Link to="/about">ABOUT</Link>

              <AnimatePresence>
                {openDropdown === "about" && (
                  <motion.ul {...dropdownAnim} className="dropdown-menu show">
                    <li>
                      <Link to="/about/client-testimonials">
                        CLIENT TESTIMONIALS
                      </Link>
                    </li>
                    <li>
                      <Link to="/about/why-choose-us">
                        WHY CHOOSE US
                      </Link>
                    </li>
                  </motion.ul>
                )}
              </AnimatePresence>
            </li>

            <li><NavLink to="/industries">INDUSTRIES</NavLink></li>
            <li><NavLink to="/services">SERVICES</NavLink></li>
            <li><NavLink to="/resources">RESOURCES</NavLink></li>
            <li><NavLink to="/jobs">JOBS</NavLink></li>
            <li><NavLink to="/contact">CONTACT</NavLink></li>
          </ul>

          {/* RIGHT SIDE */}
          <div className="nav-right d-none d-lg-flex">
            <div className="search-icon">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="2" />
                <circle cx="18" cy="18" r="2" stroke="currentColor" strokeWidth="2" />
              </svg>
            </div>

            <div className="cta-container">
              <Link to="/contact" className="talk-btn text-decoration-none">
                LET'S TALK
                <svg className="arrow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </Link>
            </div>
          </div>

          {/* MOBILE HAMBURGER */}
          <button className="hamburger d-lg-none" onClick={openMobile}>
            <span></span>
            <span></span>
            <span></span>
          </button>

        </nav>

        {/* MOBILE MENU */}
        <div className="offcanvas offcanvas-end" id="mobileMenu">
          <div className="offcanvas-header">
            <h5>MENU</h5>
            <button className="btn-close" onClick={closeMobile}></button>
          </div>

          <div className="offcanvas-body">
            <ul className="nav flex-column">

              <li><NavLink to="/" onClick={closeMobile}>HOME</NavLink></li>

              <li>
                <div onClick={() => toggleDropdown("mAbout")}>ABOUT</div>
                <AnimatePresence>
                  {openDropdown === "mAbout" && (
                    <motion.ul {...dropdownAnim}>
                      <li><Link to="/about/client-testimonials" onClick={closeMobile}>CLIENT TESTIMONIALS</Link></li>
                      <li><Link to="/about/why-choose-us" onClick={closeMobile}>WHY CHOOSE US</Link></li>
                    </motion.ul>
                  )}
                </AnimatePresence>
              </li>

              <li><NavLink to="/industries" onClick={closeMobile}>INDUSTRIES</NavLink></li>
              <li><NavLink to="/services" onClick={closeMobile}>SERVICES</NavLink></li>
              <li><NavLink to="/resources" onClick={closeMobile}>RESOURCES</NavLink></li>
              <li><NavLink to="/jobs" onClick={closeMobile}>JOBS</NavLink></li>
              <li><NavLink to="/contact" onClick={closeMobile}>CONTACT</NavLink></li>

            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

